export default {
  components: {
    findOutMore: {
      freeDessert: 'Kostenloses Dessert',
      freeDessertNextVisit: 'Kostenloses Dessert bei Ihrem nächsten Besuch',
      iWorkHard: 'Ich arbeite hart daran, Ihre Zeit so angenehm wie möglich zu gestalten. Bitte bewerten Sie meinen Service.',
      weAlwaysWantToDoBetter: 'Wir möchten immer besser werden. Bitte warten Sie, während wir Ihre Feedback-Fragen vorbereiten.',
      weJustNeedOneMinuteOfYourTime: 'Wir benötigen nur 1 Minute Ihrer Zeit.',
      youWillBeAskedAFewQuestions: 'Es werden Ihnen einige Fragen zu Ihrem Erlebnis gestellt.',
      yourFeedbackWillGoDirectlyToMe: 'Ihr Feedback wird direkt an mich weitergeleitet.'
    }
  }
};